import { defineStore } from 'pinia'

export const useTabStore = defineStore({
    id: 'tab',

    state: () => {
        return {
            tabs: {}
        }
    },

    actions: {        
        toggle ({scope, name}) {
            if (this.tabs[scope]) this.tabs[scope] = name;
            else this.tabs[scope] = name;
        }
    }
});
